import appMessages from '../../../containers/App/messages';
import messages from './messages';

function Validation(values, intl) {
  const errors = {};

  if (values.buyPrice) {
    if (values.buyPrice < 0) {
      errors.buyPrice = intl.formatMessage(appMessages.not_positive_number);
    }
  }

  if (values.grossPrice) {
    if (values.grossPrice < 0) {
      errors.grossPrice = intl.formatMessage(appMessages.not_positive_number);
    }
  }

  if (values.startDate && values.endDate) {
    if (values.startDate > values.endDate) {
      errors.startDate = intl.formatMessage(messages.start_lt_end_date);
    }
  }

  return errors;
}

export default Validation;
